import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewsCropSchema() {
  const { t } = useTranslation()

  return z.object({
    postImage: z
      .instanceof(File, { message: t('zod:errors.invalid_type') })
      .optional(),
  })
}

export type NewsCropForm = z.infer<ReturnType<typeof NewsCropSchema>>
